import {
	SET_CCBP_AMOUNT,
	SET_CCBP_C1_BANNER,
	SET_CCBP_PAYMENT_MODE,
	SET_SM_TXN_STATUS,
	SET_CCBP_TXN_STATUS,
	SET_CCBP_SELECTED_BANK,
	SET_CCBP_NEW_ORDER,
	SET_CCBP_SELECTED_ORDER,
	SET_CCBP_SELECTED_CARD,
	SET_PAGE_FLOW,
	RESET_CCBP,
	RESET_AMOUNT,
	RESET_VAS,
	SET_VAS,
	SET_ADDITIONAL_AMOUNT,
	RESET_ADDITIONAL_AMOUNT,
} from 'redux/actionTypes';

const initialState = {
	c1Banner: [],
	paymentSelectionModalState: false,
	sendMoneyTxnStatus: false,
	ccbpTxnStatus: false,
	amount: null,
	isNewOrder: true,
	selectedBank: {},
	selectedCard: null,
	orderDetails: null,
	pageFlow: null,
	vasProduct: [],
	additionalAmount: 0,
};

const CcbpReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CCBP_AMOUNT:
			return {
				...state,
				amount: action.payload,
			};
		case SET_CCBP_C1_BANNER:
			return {
				...state,
				c1Banner: action.payload,
			};
		case SET_CCBP_PAYMENT_MODE:
			return {
				...state,
				paymentSelectionModalState: action.payload,
			};
		case SET_SM_TXN_STATUS:
			return {
				...state,
				sendMoneyTxnStatus: action.payload,
			};

		case SET_CCBP_TXN_STATUS:
			return {
				...state,
				ccbpTxnStatus: action.payload,
			};
		case SET_CCBP_NEW_ORDER:
			return {
				...state,
				isNewOrder: action.payload,
			};
		case SET_CCBP_SELECTED_BANK:
			return {
				...state,
				selectedBank: action.payload,
			};
		case SET_CCBP_SELECTED_ORDER:
			return {
				...state,
				orderDetails: action.payload,
			};
		case SET_CCBP_SELECTED_CARD:
			return {
				...state,
				selectedCard: action.payload,
			};
		case SET_PAGE_FLOW:
			return {
				...state,
				pageFlow: action.payload,
			};

		case SET_VAS:
			return {
				...state,
				vasProduct: action.payload,
			};
		case RESET_VAS:
			return {
				...state,
				vasProduct: initialState.vasProduct,
				// additionalAmount: initialState.additionalAmount,
			};

		case SET_ADDITIONAL_AMOUNT:
			return {
				...state,
				additionalAmount: action.payload,
			};
		case RESET_ADDITIONAL_AMOUNT:
			return {
				...state,
				additionalAmount: initialState.additionalAmount,
			};

		case RESET_AMOUNT:
			return {
				...state,
				amount: initialState.amount,
				sendMoneyTxnStatus: initialState.sendMoneyTxnStatus,
				orderDetails: initialState.orderDetails,
				ccbpTxnStatus: initialState.ccbpTxnStatus,
				selectedBank: initialState.selectedBank,
			};
		case RESET_CCBP:
			return initialState;
		default:
			return state;
	}
};

export default CcbpReducer;
